import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import * as actions from "../../redux/actions";
import QRCode from 'qrcode.react';
const bucketUrlIndex = process.env.REACT_APP_BUCKET_URL_INDEX;

const DisplayQRcode = () => {
  const [qrURL, setQrURL] = useState('');
  const { variant, session_id } = useSelector(state => ({
    variant: state.variant,
    session_id: state.session_id,
  }));

  const dispatch = useDispatch();

  const onClose = e => {
    dispatch(actions.setQRView(false));
  };

  const generateLink = () => {
    let redirectURL = ``;

    if(session_id) {
      redirectURL = `${bucketUrlIndex}?variant=${variant}&session_id=${session_id}&origin=external`;
    } else {
      redirectURL = `${bucketUrlIndex}?variant=${variant}&origin=external`;
    }

    setQrURL(redirectURL)
  };

  useEffect(() => {
    generateLink();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="DisplayQRcode">
      <div className="DisplayQRcode-Content">
        <section className="Close-Modal" >
          <button onClick={onClose}>X</button>
        </section>
        <hr />
        <section className="Modal-Header">
          <h2>View in Augmented Reality</h2>
        </section>
        <hr />
        <section className="Modal-Body">
          <div className="QRCode">
            <section className="QRborder">
              <section className="QRborder-inner">
              {
                (qrURL.length > 0) ? (
                  <QRCode
                    value={qrURL}
                    size={250}
                    level={"H"}
                    includeMargin={true}
                  />
                ) : (
                  <div></div>
                )
              }
              </section>
            </section>
          </div>
        </section>
        <hr />
        <section className="Modal-Footer">
          <p>Scan this QR code with your phones camera</p>
        </section>
      </div>
    </div>
  )
}

export default DisplayQRcode;
